<template>
    <div class="wrap">
        <p>this is the media tab content</p>
    </div>
</template>
<script>
export default {};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tour/TourMediaTab.vue